module.exports = __webpack_public_path__ + "static/media/RPR 2b1.b4359f8f.jpg";